import clsx from 'clsx'

import { RoleType, Member } from '@tribeplatform/gql-client/types'
import { Badge, BadgeSize } from '@tribeplatform/react-ui-kit/Badge'

export const RoleBadge = ({
  member,
  className,
  size = 'md',
  ...rest
}: {
  member: Member
  className?: string
  size?: BadgeSize
}) => {
  if (!member) return null

  if (member?.role?.type === RoleType.ADMIN)
    return (
      <Badge size={size} rounded className={clsx('mx-2', className)} {...rest}>
        Admin
      </Badge>
    )

  if (member?.role?.type === RoleType.MODERATOR)
    return (
      <Badge size={size} rounded className={clsx('mx-2', className)} {...rest}>
        Mod
      </Badge>
    )

  return null
}
